<template>
  <div>
    Authentication complete. You can return to the application. Feel free to close this browser tab.
  </div>
</template>
<script>
import Cookies from "js-cookie";
import store from '../store';

export default {
  name: 'RedirectFromLogin',
  data() {
    return {
      parameterURL: [],
    };
  },
  watch: {
  },
  mounted: async function () {
    let self = this;
    for (let key in self.$route.query) {
      self.parameterURL[key.toLowerCase()] = self.$route.query[key];
    }
    if(self.parameterURL.user == 'true')
    {
      await self.GetUserProfile();
    }
    else if(self.parameterURL.userchat == 'true')
    {
      await self.GetUserChatProfile();
    } 
  },
  methods: {
    async GetUserProfile() {
      let self = this;
      self.$call.GetUserProfile(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            if(dataResponse.data != null)
            {
              var User = dataResponse.data;
              Cookies.set('userId', User.userId);
              Cookies.set('username', User.username);
              Cookies.set('fullName', User.fullName);
              Cookies.set('roleId', User.roleId);
              Cookies.set('authenticated', true);
              store.state.status = 'success';
              store.state.token = User.token;
              store.state.userid = User.userId;
              store.state.username = User.username;
              // store.state.user = response.data.data;
              store.state.fullName = User.fullName;
              store.state.roleId = User.roleId;
              store.state.isLoggedIn = true;
              localStorage.setItem('flag', 'us');
              localStorage.setItem('locale', 'en');
              store.state.languages = 'en';
              // localStorage.setItem("Version", dataResponse.data.version);
              // sessionStorage.setItem("Version", dataResponse.data.version);
              
              // ใน myWindow
              window.onbeforeunload = async function() {
                  // ข้อมูลที่ต้องการส่งกลับ
                  const data = {
                      cookies: document.cookie,
                      sessionUserId: User.userId,
                      sessionUsername: User.username,
                      sessionFullName: User.fullName,
                      sessionRoleId: User.roleId,
                  };
                  // ส่งข้อมูลกลับไปยัง parent window
                  await window.opener.postMessage(data, '*');
              };

            }
            window.close();
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async GetUserChatProfile() {
      let self = this;
      self.$call.GetUserChatProfile(
          async (dataResponse) => {
            if (dataResponse.status != 0 || dataResponse.data == null) {
              return;
            }

            var User = dataResponse.data;
            
            localStorage.setItem('token_Snippet', User.token);
            localStorage.setItem('username_Snippet', User.username);
            localStorage.setItem('email_Snippet', User.email);
            localStorage.setItem('isSnippet', true);

            Cookies.set('token_Snippet', User.token);
            Cookies.set('username_Snippet', User.username);
            Cookies.set('email_Snippet', User.email);
            Cookies.set('isSnippet', true);

            sessionStorage.setItem('token_Snippet', User.token);
            sessionStorage.setItem('username_Snippet', User.username);
            sessionStorage.setItem('email_Snippet', User.email);
            sessionStorage.setItem('isSnippet', true);

            const data = self.buildUserChatMessageData();
            const canPostToOpener = window.opener && !window.opener.closed;

            if(canPostToOpener)
            {
              try {
                window.opener.postMessage(data, '*');
                if (self.isLineProvider()) {
                  localStorage.removeItem('lineSSOReturnUrl');
                }
                window.close();
              }
              catch(err) {
                console.error('SSO postMessage failed:', err);
                self.handleStandaloneChatLogin();
              }
            }
            else
            {
              self.handleStandaloneChatLogin();
            }
          },
          (errorResource) => {
            console.error(errorResource);
          }
      );
    },
    buildUserChatMessageData() {
      return {
        cookies: document.cookie,
        sessionToken: sessionStorage.getItem('token_Snippet'),
        sessionUsername: sessionStorage.getItem('username_Snippet'),
        sessionEmail: sessionStorage.getItem('email_Snippet'),
        sessionIsSnippet: sessionStorage.getItem('isSnippet'),
      };
    },
    isLineProvider() {
      return String(this.parameterURL.provider || '').toLowerCase() == 'line';
    },
    handleStandaloneChatLogin() {
      if (this.isLineProvider()) {
        this.redirectStandaloneLineLogin();
        return;
      }

      window.close();
    },
    redirectStandaloneLineLogin() {
      const returnUrl = this.getSafeReturnUrl(this.parameterURL.returnurl || localStorage.getItem('lineSSOReturnUrl'));
      localStorage.removeItem('lineSSOReturnUrl');
      if (returnUrl) {
        window.location.replace(this.buildStandaloneLineReturnUrl(returnUrl));
        return;
      }

      this.$router.replace({
        name: 'Snippet',
        query: {
          snippet: 'true',
          domainname: this.parameterURL.domainname,
        },
      });
    },
    getSafeReturnUrl(returnUrl) {
      if (!returnUrl) {
        return null;
      }

      try {
        const parsedUrl = new URL(returnUrl, window.location.origin);
        if (parsedUrl.origin == window.location.origin || this.isAllowedLineEmbedReturnUrl(parsedUrl)) {
          return parsedUrl.href;
        }
      }
      catch (err) {
        console.error('Invalid LINE SSO returnUrl:', err);
      }

      return null;
    },
    isAllowedLineEmbedReturnUrl(parsedUrl) {
      const domainName = String(this.parameterURL.domainname || '').toLowerCase();
      return this.isLineProvider() && domainName && parsedUrl.hostname.toLowerCase() == domainName;
    },
    buildStandaloneLineReturnUrl(returnUrl) {
      const parsedUrl = new URL(returnUrl, window.location.origin);
      if (parsedUrl.origin == window.location.origin) {
        return parsedUrl.href;
      }

      const hash = parsedUrl.hash ? parsedUrl.hash.substring(1) : '';
      const hashParts = hash ? hash.split('&').filter(part => part.indexOf('fusionLineSso=') != 0) : [];
      hashParts.push(`fusionLineSso=${this.buildLineSsoPayload()}`);
      parsedUrl.hash = hashParts.join('&');
      return parsedUrl.href;
    },
    buildLineSsoPayload() {
      const data = this.buildUserChatMessageData();
      const payload = JSON.stringify({
        token: data.sessionToken,
        username: data.sessionUsername,
        email: data.sessionEmail,
        isSnippet: data.sessionIsSnippet || 'true',
      });
      const base64UrlPayload = btoa(encodeURIComponent(payload)).split('+').join('-').split('/').join('_');
      if (base64UrlPayload.endsWith('==')) {
        return base64UrlPayload.slice(0, -2);
      }
      if (base64UrlPayload.endsWith('=')) {
        return base64UrlPayload.slice(0, -1);
      }
      return base64UrlPayload;
    },
  },
};
</script>

<style scoped>
</style>
